import classNames from "../../../../utils/classNames";
import PriceFormat from "../../../../utils/priceFormat";
import EditablePartRow from "./EditablePartRow";

export default function PartsBreakdownPanel({
  partsList,
  expanded,
  partPrices,
  editingPart,
  editingPartValue,
  onPartInputChange,
  onStartEdit,
  onSave,
  onCancel,
  total,
}: {
  partsList: string[];
  expanded: boolean;
  partPrices: Record<string, number>;
  editingPart: string | null;
  editingPartValue: string;
  onPartInputChange: (value: string) => void;
  onStartEdit: (part: string) => void;
  onSave: () => void;
  onCancel: () => void;
  total: number;
}) {
  return (
    <div
      className={classNames(
        "overflow-hidden transition-all duration-300 ease-in-out",
        expanded ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"
      )}
    >
      <div className="mt-3 divide-y divide-green-100 rounded-lg border border-green-200 bg-green-50/30">
        <div className="flex items-center justify-between px-3 py-2">
          <span className="text-[10px] font-semibold uppercase tracking-wider text-green-700">
            Parts Breakdown
          </span>
          <span className="text-[10px] font-medium text-gray-500">
            {Object.keys(partPrices).length} / {partsList.length} priced
          </span>
        </div>

        {partsList.map((part) => (
          <EditablePartRow
            key={part}
            label={part}
            value={partPrices[part]}
            isEditing={editingPart === part}
            inputValue={editingPartValue}
            onInputChange={onPartInputChange}
            onStartEdit={() => onStartEdit(part)}
            onSave={onSave}
            onCancel={onCancel}
          />
        ))}

        {Object.keys(partPrices).length > 0 && (
          <div className="flex items-center justify-between bg-green-100/50 px-3 py-2">
            <span className="text-xs font-semibold text-green-800">Total Parts Value</span>
            <span className="text-sm font-bold text-green-800">{PriceFormat(total)}</span>
          </div>
        )}
      </div>
    </div>
  );
}
